import { ApiReportType } from '@kaiizen/kai-pro-api';
import { useCachedAsyncExport } from './useCachedAsyncExport';

/**
 * Hook to export a scan as Excel and poll for completion.
 *
 * For the given scan ID and options, it will prepare and eventually return the URL for the Excel file.
 *
 * @param scanId - The scan ID to export, or null to disable
 * @param options - Polling options including report type
 */
export const useScanExcelExport = (
  scanId: string | undefined,
  reportType: ApiReportType,
) =>
  useCachedAsyncExport({
    scanId,
    reportType,
    label: 'Excel',
    method: 'exportScopePurchaseOrder',
  });
